<script>
import apigeneric from "@/helpers/apigeneric";
export default {
  mixins: [apigeneric],
  data() {
    return {
      ActivitiesData: {},
    };
  },
  methods: {
    getLang() {
      return localStorage.getItem("lang") || "tr";
    },
    getFirstImage(gallery) {
      if (gallery && typeof gallery === 'string' && gallery.trim() !== '') {
        return gallery.split(',')[0].trim();
      }
      return '';
    },
    handleImgError(e) {
      e.target.style.display = 'none';
      if (e.target.parentElement) {
        const fallback = e.target.parentElement.querySelector('.img-fallback-icon');
        if (fallback) fallback.style.display = 'flex';
      }
    },
    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "3",
        PageDataSize: "1",
      };
      this.ActionsFilterGet({
        Service: "activities",
        Page: Page,
      }).then((res) => {
        this.ActivitiesData = res.Data;
      });
    },
  },
};
</script>

<template>
  <section>
    <div class="home-news">
      <div class="title c-flex flex-column">
        <a :href="'/fullactivities/' + getLang()" class="card-link"><h3>Etkinlikler</h3></a>
        <p>En güncel etkinliklerimize buradan ulaşabilirsiniz</p>
      </div>
      <div class="container">
        <div class="row align-items-stretch">
          <div
            class="col-md-4 mb-4 d-flex align-items-stretch"
            v-for="(Data, index) in ActivitiesData"
            :key="index"
          >
            <div class="card w-100 d-flex flex-column">
              <div class="card-img-wrapper">
                <img
                  v-if="getFirstImage(Data.Imagegallery)"
                  :src="$config.FILES_URL + 'web/' + getFirstImage(Data.Imagegallery)"
                  class="card-img-top"
                  alt=""
                  @error="handleImgError"
                />
                <div class="img-fallback-icon" :style="{ display: getFirstImage(Data.Imagegallery) ? 'none' : 'flex' }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#ffffff" opacity="0.85" viewBox="0 0 16 16">
                    <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                  </svg>
                </div>
              </div>
              <div class="card-body d-flex flex-column flex-grow-1">
                <h5 class="card-date">{{ Data.Startdate | formatDateTime }}</h5>
                <h5 class="card-title mt-3">
                  {{ Data.Title }}
                </h5>
                <p class="card-text flex-grow-1">
                  <span v-html="Data.Description"></span><br />
                </p>
                <a
                  :href="'/activitydetails/' + getLang() + '/' + Data.Title.toLowerCase()
                    .replace(/I|İ/gi, 'i')
                    .replace(/Ğ|ğ/gi, 'g')
                    .replace(/Ç|ç|ğ/gi, 'c')
                    .replace(/\s+/g, '-')
                    .replace(/&/g, '-and-')
                    .replace(/--/g, '-') + '/' + Data.Id"
                  class="card-link mt-auto"
                >
                  Devamını Oku →
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-4">
          <a :href="'/fullactivities/' + getLang()" class="btn-more-show">
            Daha Fazla Göster &rarr;
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.home-news .card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.home-news .card .card-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}
.home-news .card .card-body .card-text {
  flex-grow: 1;
}
.home-news .card .card-body .card-link {
  margin-top: auto;
}
.card-img-wrapper {
  width: 100%;
  height: 200px;
  background-color: #00758f;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-news .card .card-img-top {
  width: 100%;
  height: 200px;
  object-fit: contain;
  background-color: #00758f;
}
.img-fallback-icon {
  width: 100%;
  height: 100%;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00758f;
}
.btn-more-show {
  display: inline-block;
  background-color: #00758f;
  color: #ffffff !important;
  font-weight: 700;
  font-size: 14px;
  padding: 10px 30px;
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 117, 143, 0.2);
}
.btn-more-show:hover {
  background-color: #005a6e;
  color: #ffffff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 117, 143, 0.35);
}
</style>
